import { createContext } from 'react'

// simplified way to expose drawer functions down the component tree without prop drilling
export const DrawerContext = createContext({
  onClose: () => {},
  onExit: () => {},
  onSaveDraft: () => {},
})
